import * as paper from 'paper';
import {Point} from "paper";

export class CookTopSplashItem {
    static didMoveCookTopSplash = false;
    static selectedCookTopSplash: any = null;

    static setSelectedCookTopSplash(mySelectedCookTopSplash: any) {
        CookTopSplashItem.didMoveCookTopSplash = false;
        CookTopSplashItem.selectedCookTopSplash = mySelectedCookTopSplash;
    }

    static hasEnumType(typeEnum: number): boolean {
        return CookTopSplashItem.selectedCookTopSplash && CookTopSplashItem.selectedCookTopSplash.data && CookTopSplashItem.selectedCookTopSplash.data.typeID && CookTopSplashItem.selectedCookTopSplash.data.typeID.typeEnum == typeEnum;
    }

    static movingCookTopSplash(delta: any) {
        CookTopSplashItem.selectedCookTopSplash.bringToFront();
        CookTopSplashItem.didMoveCookTopSplash = true;

        var cookTopSplashPosition = new Point(CookTopSplashItem.selectedCookTopSplash.position);

        cookTopSplashPosition.x += delta.x;
        cookTopSplashPosition.y += delta.y;
        CookTopSplashItem.selectedCookTopSplash.position = cookTopSplashPosition;
    }

}
